// plugins/vuetify.js — Vuetify 1.5 initialisation.
// Purpose: install Vuetify as a Vue plugin (v1.5 is installed via Vue.use, NOT a
// `new Vuetify()` instance like v2) and load its stylesheet. Imported for its
// side effect from src/main.js before the root instance is created.
// Reconstructed from lacak.io deployed behavior (Vue 2.7 + Vuetify 1.5.24);
// app-specific contract verbatim, internal impl re-authored.

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  // Vuetify 1.5 default iconfont; Material Icons stylesheet is added in index.html.
  iconfont: 'md',
  theme: {
    primary: '#1e96dc', // recovered brand tint (default icon_color "1E96DC")
    secondary: '#37474f',
    accent: '#1e96dc',
    error: '#e53935',
    info: '#1e96dc',
    success: '#43a047',
    warning: '#fb8c00'
  }
})
